// extracted by mini-css-extract-plugin
module.exports = {"customScrollbar":"jR3tA","thumbVertical":"K7dr3"};